import React, { useState, useEffect } from 'react';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import { DescripcionFuente } from '../funciones/FuncionesInformacion.js';
import * as UI from '../constantes/UI.js';
import MensajeError from '../UI/MensajeError.js';
import { encontrarIdNumber } from '../funciones/FuncionesArray.js';

const SelectFuenteInformacion = (props) => {
  const fuenteActual = props.idActual;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const [listaOriginal, setListaOriginal] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { ITEM_COMBO_VACIO } = UI.useUI();

  const itemActual = fuenteActual
    ? { id: fuenteActual.id, descripcion: DescripcionFuente(fuenteActual) }
    : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const setListaFuentes = (fuentesInformacion) => {
      let lista = fuentesInformacion.map((item) => ({
        id: item.id,
        descripcion: DescripcionFuente(item),
      }));
      if (incluirNulo) {
        lista = [{ id: null, descripcion: ITEM_COMBO_VACIO }, ...lista];
      }
      setLista(lista);
      setListaOriginal(fuentesInformacion);
    };

    fetchData('fuentes_informacion', setListaFuentes);
  }, [fetchData, incluirNulo, ITEM_COMBO_VACIO]);

  const onItemElegido = (itemElegido) => {
    if (itemElegido) {
      props.onFuenteElegida(encontrarIdNumber(listaOriginal, itemElegido.id));
    }
  };

  let valorActual = '';
  if (itemActual) {
    if (itemActual.id) {
      valorActual = itemActual;
    } else if (lista.length > 0) {
      for (const element of lista) {
        if (Number(element.id) === Number(itemActual.id)) {
          valorActual = element.id;
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.CODIGO}
        campoDescripcion="descripcion"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectFuenteInformacion;
